import React from "react";
import danny from "../img/legado/danny.jpeg";
import jenny from "../img/legado/jenny.jpeg";
import patricia from "../img/legado/patricia.jpeg";
import stefania from "../img/legado/stefania.jpeg";
import victoria from "../img/legado/victoria.jpeg";

const ponentesData = [
  {
    id: 1,
    nombre: "Stefanía Antonella Erazo Lucero",
    titulo: "Especialista en psicooncología y cuidados paliativos",
    contenido:
      "Su historia de vida está marcada por haber enfrentado un cáncer hematológico y un trasplante de médula ósea mientras culminaba su formación universitaria, llegando incluso a defender su tesis pocos días después de recibir el alta médica. Transformó esa experiencia en una misión de vida: acompañar a pacientes y familias desde una mirada profundamente humana. Investigadora, docente y conferencista TEDx, ha consolidado una trayectoria que integra excelencia académica, experiencia vivida y compromiso con el bienestar emocional.",
    foto: stefania,
  },
  {
    id: 2,
    nombre: "Patricia Sofía Faggioni Luna",
    titulo: "Fundadora de Elemental Psicología Integral",
    contenido:
      "Fundadora de la primera empresa especializada en servicios psicológicos de la provincia de Loja. En 2023 convirtió su visión de promover el bienestar emocional en una organización pionera dedicada a la prevención, promoción e intervención en salud mental. Lidera un equipo interdisciplinario conformado por profesionales Alumni UTPL, comprometidos con una atención ética, humanista y basada en evidencia. Su trabajo impulsa una atención integral, accesible y de calidad, consolidando un modelo innovador que fortalece la salud mental y la calidad de vida de las personas en la región.",
    foto: patricia,
  },
  {
    id: 3,
    nombre: "Danny Alexander Avila Saritama",
    titulo: "Primer árbitro lojano con escarapela FIFA",
    contenido:
      "Es el primer lojano en obtener la escarapela FIFA, distinción que ha sido ratificada en seis ocasiones desde 2021. Su trayectoria es el resultado de una vocación cultivada desde la infancia, basada en la disciplina, la constancia y una sólida formación académica. Además de dominar el inglés y el francés, promueve el arbitraje como una profesión sustentada en la ética, el liderazgo y los valores, demostrando que la excelencia deportiva también se construye desde la preparación integral.",
    foto: danny,
  },
  {
    id: 4,
    nombre: "Victoria Fernanda Buendía Terneus",
    titulo: "Traductora profesional en EE. UU.",
    contenido:
      "Docente de formación en Ecuador, migró a Estados Unidos donde su título de la UTPL le permitió certificarse como traductora profesional y desarrollarse en el sector público en traducción técnica. Ha realizado más de 1.000 proyectos pro-bono para organizaciones internacionales. Su principal reto fue la adaptación profesional y cultural en un entorno altamente competitivo, donde la formación de la UTPL fue clave para su inserción y continuidad en estudios de posgrado.",
    foto: victoria,
  },
  {
    id: 5,
    nombre: "Jenny Fabiola Nantip Shirimbo",
    titulo: "Representante del pueblo Shuar y profesional UTPL",
    contenido:
      "Mujer del pueblo Shuar, ejemplo de perseverancia y superación, logró alcanzar los sueños que se propuso desde el inicio. Mientras trabajaba y estudiaba, encontró en su familia la mayor motivación para seguir adelante, convirtiendo cada dificultad en una oportunidad para crecer. Gracias a la flexibilidad y el acompañamiento de la UTPL, transformó el esfuerzo en logros, iniciando su trayectoria profesional como pasante en la institución donde hoy trabaja y ejerce una función representativa. Su historia demuestra que, cuando los sueños tienen un propósito claro y se persiguen con esfuerzo y fe, sí se cumplen.",
    foto: jenny,
  },
];

export default function LegadoPonentes() {
  return (
    <section className="bg-gray-50 py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Título de la sección */}
        <div className="text-center mb-12">
          <p className="inline-flex items-center px-3 py-1 text-xs mb-6 font-medium text-[#004270] bg-amber-100 rounded-full dark:bg-indigo-950 dark:text-indigo-300">
            Historias de éxito
          </p>
          <h2>Legado que trasciende</h2>
          <p>
            Historias de éxito, perseverancia e impacto de nuestros ponentes.
          </p>
        </div>

        {/* Grid de Tarjetas */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {ponentesData.map((ponente) => (
            <div
              key={ponente.id}
              className="flex flex-col bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 border border-gray-100"
            >
              {/* Contenedor de Foto */}
              <div className="relative h-[350px] w-full bg-gray-200">
                <img
                  src={ponente.foto}
                  alt={ponente.nombre}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Contenido de la Tarjeta */}
              <div className="flex-1 p-6 flex flex-col justify-between">
                <div>
                  <h3>{ponente.nombre}</h3>
                  <p className="text-sm font-semibold text-slate-600 mt-1 mb-4">
                    {ponente.titulo}
                  </p>
                  <p>{ponente.contenido}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
